export default "__VITE_ASSET__DgmqxnZf__"